import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField
} from '@mui/material';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const ORANGE = 'rgb(203, 100, 35)';

function DateField({ name, label, value, onChange, inputRef, error, ...props }) {
  return (
    <DatePicker
      value={value ?? null}
      onChange={onChange}
      PopperProps={{
        placement: 'bottom-start'
      }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={(ref) => {
            if (params.inputRef) {
              params.inputRef(ref);
            }

            if (inputRef) {
              inputRef(ref);
            }
          }}
          id={name}
          label={label}
          size="small"
          margin="dense"
          fullWidth
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}

export default function GreatDateRangePickerButton({
  value = {
    from: null,
    to: null
  },
  onChange,
  selected = false,
  disabled = false,
  minDate,
  maxDate,
  sx
}) {
  const [open, setOpen] = useState(false);

  const [from, setFrom] = useState(value.from);
  const [to, setTo] = useState(value.to);

  useEffect(() => {
    setFrom(value.from);
    setTo(value.to);
  }, [value]);

  const handleClose = () => {
    setFrom(value.from);
    setTo(value.to);
    setOpen(false);
  };

  const handleApply = () => {
    onChange?.({
      from,
      to
    });

    setOpen(false);
  };

  return (
    <>
      <IconButton
        disabled={disabled}
        onClick={() => setOpen(true)}
        sx={{
          minWidth: 60,
          width: 60,
          height: 40,
          border: '1px solid',
          borderColor: selected ? ORANGE : 'divider',
          backgroundColor: selected ? ORANGE : 'transparent',
          color: selected ? '#fff' : '#9E9E9E',

          '& .MuiSvgIcon-root': {
            color: selected ? '#fff' : '#9E9E9E'
          },

          '&:hover': {
            backgroundColor: selected ? ORANGE : 'rgba(203,100,35,.08)'
          },

          ...sx
        }}>
        <CalendarMonthIcon />
      </IconButton>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Select Date Range</DialogTitle>

        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2} mt={1}>
              <DateField
                name="from"
                label="From"
                value={from}
                onChange={setFrom}
                minDate={minDate}
                maxDate={to || maxDate}
              />

              <DateField
                name="to"
                label="To"
                value={to}
                onChange={setTo}
                minDate={from || minDate}
                maxDate={maxDate}
              />
            </Stack>
          </LocalizationProvider>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>

          <Button
            variant="contained"
            onClick={handleApply}
            disabled={!from || !to}
            sx={{
              backgroundColor: ORANGE,
              '&:hover': {
                backgroundColor: ORANGE
              }
            }}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
